<template>
  <div class="store-info" :class="'store-info_type-'+config.store_info_style">
    <div class="bg-image" :style="bgStyle"></div>
    <div class="info-block">
      <div class="store-logo">
        <img :src="config.logo_image_url" alt="">
      </div>
      <div class="info-panel">
        <p class="store-name" :style="{color: config.store_name_color}">{{config.store_name}}</p>
        <div class="store-goods" :style="{color: config.store_summary_color}">{{config.store_summary}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Common from '../mixins/Common';

  export default {
	name: 'StoreInfo',
	props: {},
	mixins: [Common],
	components: {},
	data() {
	  return {};
	},
	created() {
	},
	methods: {},
	computed: {
	  bgStyle() {
		return {
		  backgroundImage: `url(${this.config.background_image})`
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .store-info {
    background-color: #fff;

    .bg-image {
      background-size: cover;
      background-position: center;
      position: relative;
      height: 100%;

      &:before, &:after {
        content: '';
        pointer-events: none;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
      }

      &:after {
        height: 100%;
        background-image: linear-gradient(to top, rgba(0, 0, 0, .3), rgba(0, 0, 0, 0));
      }
    }

    .info-block {
      display: flex;
      position: relative;

      .store-logo {
        width: 80px;
        height: 80px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .store-logo {
        border-radius: 50%;
      }

      .info-panel {
        height: 80px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;

        span {
          display: inline-block;
          vertical-align: middle;
        }

        .store-name {
          font-size: 18px;
          color: #fff;
        }

        .split-line {
          margin: 0 5px;
          width: 1px;
          height: 1em;
          background-color: #fff;
        }

        .store-goods {
          font-size: 14px;
          color: #fff;
        }
      }
    }


    &.store-info_type-0 {
      height: 286px;

      .bg-image {
        height: 230px;
      }

      .info-block {
        padding-left: 20px;
        margin-top: -40px;

        .info-panel {
          .store-goods {
            color: @text-color-gray;
          }

          .split-line {
            background-color: @text-color-gray;
          }
        }
      }
    }

    &.store-info_type-1 {
      height: 230px;

      .info-block {
        padding-left: 20px;
        margin-top: -100px;

        .store-logo {
          border-radius: 8px;
        }
      }
    }

    &.store-info_type-2 {
      height: 295px;

      .bg-image {
        height: 180px;
      }

      .info-block {
        margin-top: -40px;
        flex-direction: column;
        align-items: center;

        .info-panel {
          text-align: center;
          height: 60px;
          padding-bottom: 5px;

          .store-name {
            color: @text-color-primary;
          }

          .split-line {
            background-color: @text-color-gray;
          }

          .store-goods {
            color: @text-color-gray;
          }
        }
      }
    }

    &.store-info_type-3 {
      height: 230px;

      .bg-image {
        height: 230px;

        &:before {
          height: 230px;
        }
      }

      .info-block {
        margin-top: -180px;
        flex-direction: column;
        align-items: center;

        .info-panel {
          text-align: center;
          height: 60px;
          padding-bottom: 5px;
        }
      }
    }
  }
</style>
